import React from 'react';
import PropTypes from 'prop-types';

const ImportErrorRow = ({ importError }) => {

    return (
        <div className="row">
            <div className="col-2">
                <span>Row {importError.rowNumber}</span>
            </div>
            <div className="col-2">
                <span>Column {importError.columnNumber}</span>
            </div>
            <div className="col-8">
                <span>{importError.errorMessage}</span>
            </div>
        </div>
    );
};

ImportErrorRow.propTypes = {
    importError: PropTypes.object.isRequired
};

export default ImportErrorRow;